

export const TitleSection=()=>{
    return(
        <div className="title-section">
            <div className="__container">
                <div className="title_row">
                    <div className="title_img">
                        <img src={require('../../../../static/cog-icon.png')}/>
                    </div>
                    <h2 className="title_header">
                        A NEW GENERATION OF VINTAGE BIKE
                    </h2>
                    <span className="title_text">
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.
                    </span>
                </div>
            </div>
        </div>
    )
}